export default __webpack_public_path__ + "mate-v9-latin-regular.woff2";